import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import companiesEn from './locales/en/companies.json';
import contactsEn from './locales/en/contacts.json';
import bucketsEn from './locales/en/buckets.json';
import ordersEn from './locales/en/orders.json';
import settingsEn from './locales/en/settings.json';
import onboardingEn from './locales/en/onboarding.json';
import fulfillmentsEn from './locales/en/fulfillments.json';
import viewsEn from './locales/en/views.json';
import customFieldsEn from './locales/en/customFields.json';
import validationRulesEn from './locales/en/validationRules.json';
import reportsEn from './locales/en/reports.json';
import dataManagementEn from './locales/en/dataManagement.json';
import filesEn from './locales/en/files.json';
import dashboardEn from './locales/en/dashboard.json';
import searchEn from './locales/en/search.json';
import notificationsEn from './locales/en/notifications.json';

const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    companies: companiesEn,
    contacts: contactsEn,
    buckets: bucketsEn,
    orders: ordersEn,
    settings: settingsEn,
    onboarding: onboardingEn,
    fulfillments: fulfillmentsEn,
    views: viewsEn,
    customFields: customFieldsEn,
    validationRules: validationRulesEn,
    reports: reportsEn,
    dataManagement: dataManagementEn,
    files: filesEn,
    dashboard: dashboardEn,
    search: searchEn,
    notifications: notificationsEn,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  ns: ['common', 'auth', 'companies', 'contacts', 'buckets', 'orders', 'settings', 'onboarding', 'fulfillments', 'views', 'customFields', 'validationRules', 'reports', 'dataManagement', 'files', 'dashboard', 'search', 'notifications'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false, // React handles XSS
  },
});

export function setWorkspaceLabels(_labels: {
  bucket: string;
  bucket_plural: string;
  order: string;
  order_plural: string;
}) {
  // Workspace labels are read directly from the workspace store (see Shell.tsx).
  // This function exists as a hook for future i18n interpolation integration.
}

export default i18n;
